module.exports = __webpack_public_path__ + "img/kurumaisu_icon_on.f841ba70.png";